import React from 'react';
import {Composition, registerRoot} from 'remotion';
import {HermesVideo} from './Video.jsx';
import {PROJECTS} from '../renders/projects.generated.js';
import {GENERATED_COMPOSITIONS} from '../renders/generated.registry.js';

function dimensions(project) {
  if (project.width && project.height) {
    return {width: Number(project.width), height: Number(project.height)};
  }

  return project.aspectRatio === '9:16'
    ? {width: 1080, height: 1920}
    : {width: 1280, height: 720};
}

function inputProps(project) {
  return {
    prompt: project.title,
    subtitle: project.subtitle,
    badge: project.badge,
    background: project.background,
    accent: project.accent,
    scenes: project.scenes || [],
  };
}

function compositionId(project) {
  return String(project.id || 'hermes-video').replace(/[^a-zA-Z0-9가-힣-]/g, '-');
}

const Root = () => (
  <>
    {PROJECTS.map((project) => {
      const size = dimensions(project);
      const fps = Number(project.fps || 30);
      const durationSeconds = Math.max(1, Math.min(Number(project.durationSeconds || 10), 120));

      return (
        <Composition
          key={project.id}
          id={compositionId(project)}
          component={HermesVideo}
          durationInFrames={durationSeconds * fps}
          fps={fps}
          width={size.width}
          height={size.height}
          defaultProps={inputProps(project)}
        />
      );
    })}

    {GENERATED_COMPOSITIONS.map((item) => (
      <Composition
        key={item.id}
        id={item.id}
        component={item.component}
        durationInFrames={item.durationInFrames}
        fps={item.fps}
        width={item.width}
        height={item.height}
        defaultProps={item.defaultProps || {}}
      />
    ))}
  </>
);

registerRoot(Root);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
